import React from 'react';

export const SnackbarContext = React.createContext();
